module.exports = "/images/vendor/flag-icon-css/flags/1x1/pm.svg?89993b1ff27bb0107946d29ffebcfcfa";